export default __webpack_public_path__ + "static/media/icon_accesoires.20a2f591.png";